import { render, staticRenderFns } from "./language-selector.component.html?vue&type=template&id=bcce3836&"
import script from "./language-selector.component.ts?vue&type=script&lang=ts&"
export * from "./language-selector.component.ts?vue&type=script&lang=ts&"
import style0 from "./language-selector.component.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
